module.exports = __webpack_public_path__ + "img/vartext5.d6dfbb39.svg";